import React from "react";
import useReveal from "../hooks/useReveal";
import PageHero from "../components/PageHero";
import About from "../components/About";
import WhyUs from "../components/WhyUs";
import Expert from "../components/Expert";

export default function AboutPage() {
  useReveal();
  return (
    <>
      <PageHero eyebrow="About VIIMII" title="Our Story" subtitle="A boho-luxe nail, lash & hair spa studio in Kandivali West, Mumbai - built around artistry, warmth and flawless results." />
      <About />
      <WhyUs />
      <Expert />
    </>
  );
}
